/**
 * gear sprite atlas — GENERATED, do not edit.
 *
 *   Blender --background --python tools/blender/build_items.py -- --atlas
 *   Blender --background --python tools/blender/pack_atlas.py -- ...
 *   node tools/build-item-atlas.mjs
 *
 * Frame coordinates into `/gear.webp`, rendered from `build_equipment.py` and `build_characters.py`, packed by `pack_atlas.py`.
 * One sheet is one request: on a slow connection, separate icons cost far more
 * than the icons' worth of bytes.
 */
export const GEAR_URL = '/gear.webp';
export const GEAR_CELL = 96;
export const GEAR_SIZE = { width: 576, height: 480 } as const;

export interface GearFrame {
  x: number;
  y: number;
}

const FRAMES: Readonly<Record<string, GearFrame>> = {
  "axe/axe_lv01": { x: 0, y: 0 },
  "axe/axe_lv02": { x: 96, y: 0 },
  "axe/axe_lv03": { x: 192, y: 0 },
  "axe/axe_lv04": { x: 288, y: 0 },
  "axe/axe_lv05": { x: 384, y: 0 },
  "axe/axe_lv06": { x: 480, y: 0 },
  "axe/axe_lv07": { x: 0, y: 96 },
  "axe/axe_lv08": { x: 96, y: 96 },
  "axe/axe_lv09": { x: 192, y: 96 },
  "axe/axe_lv10": { x: 288, y: 96 },
  "lamp/lamp_lv01": { x: 384, y: 96 },
  "lamp/lamp_lv02": { x: 480, y: 96 },
  "lamp/lamp_lv03": { x: 0, y: 192 },
  "lamp/lamp_lv04": { x: 96, y: 192 },
  "lamp/lamp_lv05": { x: 192, y: 192 },
  "lamp/lamp_lv06": { x: 288, y: 192 },
  "lamp/lamp_lv07": { x: 384, y: 192 },
  "lamp/lamp_lv08": { x: 480, y: 192 },
  "lamp/lamp_lv09": { x: 0, y: 288 },
  "lamp/lamp_lv10": { x: 96, y: 288 },
  "renders/character_jin_portrait": { x: 192, y: 288 },
  "renders/character_luna_portrait": { x: 288, y: 288 },
  "renders/character_mira_portrait": { x: 384, y: 288 },
  "renders/character_rocky_portrait": { x: 480, y: 288 },
  "renders/character_sakura_portrait": { x: 0, y: 384 },
  "renders/character_thor_portrait": { x: 96, y: 384 },
};

/**
 * Frame for a key, or null when the sheet has no art for it.
 *
 * Null rather than a placeholder frame is deliberate: something added before
 * its model is rendered should fall back to its emoji, not draw whatever
 * happens to sit at (0, 0).
 */
export function gearFrame(key: string): GearFrame | null {
  return FRAMES[key] ?? null;
}

export const GEAR_KEYS = Object.keys(FRAMES);
